"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 */
class Constraint {
    constructor(vars, expression) {
        this.vars = vars;
        this.expression = expression;
    }
    evaluate(store) {
        let vals = this.vars.map(v => v.getValues(store));
        let combos = this.cartesianProduct(vals);
        return combos.map(c => {
            let varsAndVals = {};
            this.vars.forEach((v, i) => varsAndVals[v.getName()] = c[i]);
            return this.expression.evaluate(varsAndVals, store);
        });
    }
    maintain(store) {
        let vals = this.vars.map(v => v.getValues(store));
        let combos = this.cartesianProduct(vals);
        combos.forEach(c => {
            let varsAndVals = {};
            this.vars.forEach((v, i) => varsAndVals[v.getName()] = c[i]);
            this.expression.maintain(varsAndVals, store);
        });
    }
    stopMaintaining() {
        this.expression.stopMaintaining();
    }
    cartesianProduct(arr) {
        return arr.reduce((a, b) => a.map(x => b.map(y => x.concat(y)))
            .reduce((a, b) => a.concat(b), []), [[]]);
    }
    getBoundVariables() {
        return this.vars;
    }
    getExpression() {
        return this.expression;
    }
    toString() {
        return this.vars.map(v => v.toString()).join(' => ') + ' => ' + this.expression.toString();
    }
}
exports.Constraint = Constraint;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/model/constraint.js
// module id = 644
// module chunks = 3